import { HashRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import Dashboard from './components/pages/dashboard/Dashboard';
import AppProviders from './contexts/AppProviders';
import SignIn from './components/pages/sign-in/SignIn';
import { RoutePaths } from './utils/enums';
import ProtectedRoutes from './routes/ProtectedRoutes';

/**
 * The main app which handles the initialization and routing
 * of the app.
 */

export default function App(): JSX.Element {
  return (
    <AppProviders>
      <Router>
        <Routes>
          <Route element={<ProtectedRoutes />}>
            <Route path="/" element={<Navigate to={RoutePaths.Dashboard} />} />
            <Route path={RoutePaths.Dashboard} element={<Dashboard />} />
          </Route>
          <Route path="*" element={<Navigate to={RoutePaths.SignIn} />} />
          <Route path={RoutePaths.SignIn} element={<SignIn />} />
        </Routes>
      </Router>
    </AppProviders>
  );
}
